import { ArrowLeftIcon, ExclamationTriangleIcon } from '@heroicons/react/24/solid';
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

import MailConfigSetup from '../../components/Setup/MailConfig/MailConfigSetup';
import { ROUTES } from '../../utils/routes';

function SetupMailConfigView() {
  const navigate = useNavigate();

  const handleGoBack = () => {
    try {
      if (window.history.state && window.history.state.idx > 0) {
        navigate(-1);
      } else {
        navigate(ROUTES.SETUP_SIMPLIFIED_DASHBOARD);
      }
    } catch {
      navigate(ROUTES.SETUP_SIMPLIFIED_DASHBOARD);
    }
  };

  return (
    <div className="mx-auto">
      <div className="mb-6">
        <button
          onClick={handleGoBack}
          className="flex items-center rounded-lg border border-gray-300 bg-white px-4 py-2 text-gray-700 transition-colors hover:bg-gray-50"
        >
          <ArrowLeftIcon className="mr-2 h-5 w-5" />
          Retour
        </button>
      </div>

      <div className="mb-8 rounded-lg bg-white p-8 shadow-md">
        <h1 className="mb-6 text-3xl font-bold text-gray-900">
          Configuration de vos mails
        </h1>
        <div className="prose prose-lg text-gray-700">
          <p>
            Configurez les paramètres d'envoi de mails pour chacun de vos référents.
            Associez chaque copropriété à un référent de marque et paramétrez leur serveur SMTP
            pour permettre l'envoi de communications depuis leur adresse email professionnelle.
          </p>
        </div>

        <div className="mt-6 rounded-lg border border-amber-200 bg-amber-50 p-4">
          <div className="flex items-start gap-3">
            <ExclamationTriangleIcon className="mt-0.5 h-6 w-6 shrink-0 text-amber-600" />
            <div className="text-sm text-amber-900">
              <p className="font-semibold">
                Information importante sur les messages envoyés
              </p>
              <p className="mt-1">
                Les emails sont bien envoyés via la configuration du référent.
                En revanche, l'affichage du message dans la boîte "Envoyés" (ou "Boîte d'envoi")
                dépend de la messagerie utilisée (Outlook, Gmail, etc.) et de ses réglages.
              </p>
              <p className="mt-1">
                Concrètement : un email peut être correctement envoyé au destinataire sans apparaître automatiquement
                dans les messages envoyés du référent.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-6 flex justify-end">
          <Link
            to={ROUTES.SETUP_SENT_MAILS}
            className="inline-flex items-center rounded-lg border border-rgpd-blue px-4 py-2 text-sm font-semibold text-rgpd-blue transition-colors hover:bg-rgpd-blue hover:text-white"
          >
            Voir les emails envoyés
          </Link>
        </div>
      </div>

      <MailConfigSetup />
    </div>
  );
}

export default SetupMailConfigView;
